import dayjs from 'dayjs';

const normalizeState = (state) => {
  if (!state) {
    return '';
  }

  if (typeof state === 'object') {
    return String(state.value || state.name || '').trim();
  }

  return String(state).trim();
};

const sameId = (left, right) => {
  if (left == null || right == null) {
    return false;
  }

  return String(left) === String(right);
};

export const isStudentActiveInSchoolYear = (
  student,
  schoolYears,
  schoolYearId,
) => {
  const studentState = normalizeState(student?.state);
  if (!student || studentState.toLowerCase() !== 'active') {
    return false;
  }

  if (!schoolYearId) {
    return true;
  }

  const schoolYear = (schoolYears || []).find((year) =>
    sameId(year.id, schoolYearId),
  );
  if (!schoolYear) {
    return false;
  }

  const schoolYearStart = schoolYear.start_year
    ? dayjs(schoolYear.start_year)
    : null;
  const schoolYearEnd = schoolYear.end_year
    ? dayjs(schoolYear.end_year)
    : schoolYearStart;

  const directStartDate = student?.date_study_start
    ? dayjs(student.date_study_start)
    : null;
  const directEndDate = student?.date_study_end
    ? dayjs(student.date_study_end)
    : null;

  if (
    directStartDate?.isValid() &&
    schoolYearStart &&
    directStartDate.isAfter(schoolYearStart)
  ) {
    return false;
  }

  if (
    directEndDate?.isValid() &&
    schoolYearEnd &&
    directEndDate.isBefore(schoolYearEnd || schoolYearStart)
  ) {
    return false;
  }

  if (directStartDate?.isValid() || directEndDate?.isValid()) {
    return true;
  }

  const startYear = student.phd_start_school_year_id
    ? (schoolYears || []).find((year) =>
        sameId(year.id, student.phd_start_school_year_id),
      )
    : null;
  const endYear = student.phd_end_school_year_id
    ? (schoolYears || []).find((year) =>
        sameId(year.id, student.phd_end_school_year_id),
      )
    : null;

  if (
    startYear?.start_year &&
    schoolYearStart &&
    dayjs(startYear.start_year).isAfter(schoolYearStart)
  ) {
    return false;
  }

  if (
    endYear?.end_year &&
    schoolYearEnd &&
    dayjs(endYear.end_year).isBefore(schoolYearEnd || schoolYearStart)
  ) {
    return false;
  }

  return true;
};
